export class DeviceRegistrationPageError {
  static readonly type = '[Device Registration] Error';
  constructor(public error: string) {}
}

export class ResetError {
  static readonly type = '[Error] Reset Error';
}
